/**
 * @fileoverview ตรวจสิทธิ์ของผู้ใช้ที่ล็อกอินอยู่ สำหรับซ่อน/แสดงปุ่มในหน้าเว็บ
 *
 * ใช้คู่กับด่านจริงฝั่ง backend (auth.middleware.checkPermission) เสมอ —
 * ที่นี่เป็นแค่ UX ไม่ใช่การป้องกัน เพราะ profile อยู่ใน localStorage ที่ผู้ใช้แก้เองได้
 *
 * รายการ key ทั้งหมดอยู่ที่ global.permission (components/global.js)
 * รูปแบบ "<โมดูล>.<action>" เช่น assets.create / users.delete
 */

import { getProfile } from "./localStorage";

const PROFILE_KEY = "mn-profile";

/* can() ถูกเรียกทุกปุ่มของทุกแถวในตาราง การ JSON.parse ใหม่ทุกครั้งจึงเปลือง
   เทียบสตริงดิบก่อน แล้วค่อย parse เฉพาะตอนโปรไฟล์เปลี่ยนจริง
   (NavbarAdmin เขียนทับคีย์นี้ทุกครั้งที่ดึงโปรไฟล์ใหม่ แคชจึงไม่ค้าง) */
let cachedRaw;
let cached = { found: false, isSuperUser: false, permissions: new Set() };

const snapshot = () => {
  const raw = localStorage.getItem(PROFILE_KEY);
  if (raw === cachedRaw) return cached;

  cachedRaw = raw;
  const profile = raw ? getProfile() : null;
  cached = {
    found: !!profile,
    // super_user ข้ามการตรวจสิทธิ์รายหน้าทั้งฝั่ง backend และ PermissionRoute
    isSuperUser: profile?.user_type === "super_user",
    permissions: new Set(profile?.role?.permission || []),
  };
  return cached;
};

/**
 * มีสิทธิ์นี้ไหม — ส่งเป็น array ได้ หมายถึง "มีข้อใดข้อหนึ่งก็พอ" (any-of)
 * ให้ผลตรงกับ checkPermission ฝั่ง backend ที่รับ array แบบเดียวกัน
 *
 * @param {string|string[]} permission
 * @returns {boolean}
 *
 * @example
 * {can("assets.create") && <button onClick={this.OpenCreate}>เพิ่มทรัพย์</button>}
 * {can(["assets.create", "assets.delete"]) && <MenuButton />}
 */
export const can = (permission) => {
  const { found, isSuperUser, permissions } = snapshot();
  if (!found) return false;
  if (isSuperUser) return true;

  const required = Array.isArray(permission) ? permission : [permission];
  return required.some((key) => permissions.has(key));
};

/**
 * มีครบทุกข้อไหม — ใช้กับปุ่มที่ทำหลายอย่างในคลิกเดียว
 * @param {string[]} permissions
 * @returns {boolean}
 */
export const canAll = (permissions = []) => permissions.every((key) => can(key));

export default can;
